import React from 'react';
import clsx from 'clsx';

import './index.scss';

import RadioInput from 'components/atoms/Input/RadioInput';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';

const PcAccordionRadioTextArea = ({
  // checkbox
  id,
  value,
  checked,
  label,
  RadioOnChange,
  // textarea
  name,
  textAreaValue,
  cmntOnChange,
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  rows,
  cols,
  // 文字数
  wordCount,
}) =>{
  return(
    <div className="PcAccordionRadioTextArea">
      <div className="pc-accordion-radio-text-area-wrapper">
        <RadioInput
          id={id}
          value={value}
          checked={checked} 
          label={label} 
          onChange={RadioOnChange}
        />
        <div className={clsx('pc-cmnt-area', { checked })}>
          <div className="arrowArea">
            <div className="pc-background-cmnt" />
          </div>
          <div className="pcCollpseAreaBackground">
            <div>
              ご検討の職種を記載してください
              <RequiredOrOptionalIcon label='任意' />
            </div>
            <TextAreaInput
              name={name}
              value={textAreaValue}
              onChange={cmntOnChange}
              onInput={onInput}
              onCompositionEnd={onCompositionEnd}
              maxLength={maxLength}
              placeholder={placeholder}
              rows={rows}
              cols={cols}
            />
            <div className='word-count'>{wordCount}</div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default PcAccordionRadioTextArea;